module.exports = __webpack_public_path__ + "static/media/OLB-Image.4066667d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/OLB-Image.png
// module id = 557
// module chunks = 0